// extracted by mini-css-extract-plugin
module.exports = {"host":"BaseAccordion_host__29XyL","summary":"BaseAccordion_summary__1RLRg","icon":"BaseAccordion_icon__2UUpQ","heading":"BaseAccordion_heading__2NZ1k"};